// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';

import OverlayTrigger from 'components/overlay_trigger';

import Constants from 'utils/constants';
import {t} from 'utils/i18n';

import Tooltip from './tooltip';

const BEFORE_COPY_TEXT = 'Copy code block';
const AFTER_COPY_TEXT = 'Copied';

type Props = {
    onCopy?: () => void;
};

const CopyButton = ({onCopy}: Props) => {
    const [isCopied, setIsCopied] = useState(false);

    const copyText = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        e.preventDefault();
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
        onCopy?.();
    };

    const tooltip = (
        <Tooltip>
            <FormattedMessage
                id={isCopied ? t('copied.message') : t('copy.block.message')}
                defaultMessage={isCopied ? BEFORE_COPY_TEXT : AFTER_COPY_TEXT}
            />
        </Tooltip>
    );

    return (
        <OverlayTrigger
            shouldUpdatePosition={true}
            delayShow={Constants.OVERLAY_TIME_DELAY}
            placement='top'
            overlay={tooltip}
        >
            <span
                className='post-code__clipboard'
                onClick={copyText}
            >
                {!isCopied && <i role='button' className='icon icon-content-copy'/>}
                {isCopied && <i role='button' className='icon icon-check'/>}
            </span>
        </OverlayTrigger>
    );
};

export default CopyButton;
